<template>
    <section class="flex gap-5 max-w-2xl p-3 h-72">
        <div class="w-full">
            <h2 class="text-2xl font-bold">{{ $t('add_a_position') }}</h2>
            <p class="text-gray-500 mt-2">{{ $t('add_position_description') }}</p>
            <p class="text-gray-500 mt-1">{{ $t('add_position_description1') }}</p>
        </div>
        <div class="w-full min-h-48 flex flex-col items-center justify-center gap-4">
            <MazSelect v-model="selectSystemRoleId" :options="systemOptions" :label="$t('choose_from_roles')" class="w-full" />
            <MazSelect v-model="selectedParentId" :options="parentOptions" :label="$t('parent_role')" class="w-full" />
            <MazInput v-model="positionName" :label="$t('role_name') + ' (' + $t('optional') + ')'" class="w-full" />
            <MazBtn @click="saveRole()">{{ $t('save') }}</MazBtn>
        </div>
    </section>
</template>

<script>
import { get_all_roles, company_positions_list, save_new_role } from '@/api/permissions';
export default {
    name: 'AddPosition',
    data() {
        return {
            positionName: '',         // Holds the name of the new position
            selectedParentId: null,   // Holds the ID of the selected parent position
            selectSystemRoleId: null,
            positions: [],
            company_positions: []
        };
    },
    mounted() {
        this.fetchPositions(); // Fetch positions when the component is mounted

    },
    computed: {
        parentOptions() {
            // Define the "Top Level" option for positions with no parent
            const topLevel = { value: null, label: 'Top Level' };
            // Map existing positions to MazSelect options format
            const positionOptions = this.company_positions.map(position => ({
                value: position.id,
                label: position.name.replace("_", " ")
            }));
            // Combine "Top Level" with other position options
            return [topLevel, ...positionOptions];
        },
        systemOptions() {
            // Define the "Top Level" option for positions with no parent
            const topLevel = { value: null, label: 'Top Level' };
            // Map existing positions to MazSelect options format
            const positionOptions = this.positions.map(position => ({
                value: position.id,
                label: position.name.replace("_", " ")
            }));
            // Combine "Top Level" with other position options
            return [topLevel, ...positionOptions];
        }
    },
    methods: {
        async fetchPositions() {
            this.company_positions = await company_positions_list(this.$cookies.get("userToken"), this.$cookies.get("c_id"));
            this.positions = await get_all_roles(this.$cookies.get("userToken"), this.$cookies.get("c_id"));
            //remove positions from company_positions that are already in positions
            this.positions = this.positions.filter((position) => {
                return !this.company_positions.some((position2) => {
                    return position.id === position2.position_id;
                });
            });
        },
        async saveRole() {
            // Prepare the payload with the new position's details
            await save_new_role(
                this.$cookies.get("userToken"), 
                this.$cookies.get("c_id"), 
                this.selectSystemRoleId, 
                this.selectedParentId, 
                this.positionName ?? null
            );
            //this should return some data that we can emit to the parent component without refreshing it
            // Emit an event to the parent component to handle the addition
            //this.$emit('add-position', payload);
        }
    }
};
</script>
